import { getAuthToken } from "../services/authService.ts";
import {
  Suspense,
  useEffect,
  useState,
} from "react";

import {
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";

import {
  AnimatePresence,
  motion,
} from "framer-motion";

import {
  useRecoilValue,
  useSetRecoilState,
} from "recoil";

import {
  selectedCategoryState,
} from "../recoil/atoms/categoryAtom";

import {
  userState,
} from "../recoil/atoms/userAtom";

import {
  storeTableId,
  useTableId,
} from "../utils/tableId";

import FlyingCart from "../components/FlyingCart";
import Footer from "../components/Footer";
import Nav from "../components/Nav";
import SplashScreen from "../components/SplashScreen";

import {
  SkeletonLoader,
} from "../components/Skeleton";

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const setSelectedCategory =
    useSetRecoilState(
      selectedCategoryState
    );

  const user =
    useRecoilValue(userState);

  const tableId = useTableId();

  const [
    showSplash,
    setShowSplash,
  ] = useState(false);

  useEffect(() => {
    const isQrEntryUrl =
      tableId &&
      location.pathname ===
      `/${tableId}`;

    if (isQrEntryUrl) {
      storeTableId(tableId);

      navigate(
        user?.fullName &&
          user?.mobileNumber && getAuthToken()
          ? "/"
          : "/login",
        {
          replace: true,
        }
      );

      return;
    }

    if (
      !user?.fullName ||
      !user?.mobileNumber || !getAuthToken()
    ) {
      if (tableId) {
        storeTableId(tableId);
      }

      navigate(
        "/login",
        {
          replace: true,
        }
      );
    }
  }, [
    user,
    tableId,
    location.pathname,
    navigate,
  ]);

  const path =
    location.pathname;

  let activePage = "home";

  if (path === "/") {
    activePage = "home";
  } else if (
    path.includes("/cart")
  ) {
    activePage = "cart";
  } else if (
    path.includes("/search")
  ) {
    activePage = "search";
  } else if (
    path.includes(
      "/account/order-history"
    )
  ) {
    activePage =
      "orderHistory";
  } else if (
    path.includes("/account")
  ) {
    activePage = "account";
  }

  const handleHomeClick = () => {
    setSelectedCategory(null);
    navigate("/");
  };

  const handleCartClick = () => navigate("/cart");
  const handleSearchClick = () => navigate("/search", { state: { tableId } });
  const handleAccountClick = () => navigate("/account");

  const outletContext = {
    handleHomeClick,

    handleAccountClick,

    handleOrderHistoryClick: () => {
      navigate(
        "/account/order-history"
      );
    },
  };

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  return (
    <div className="premium-bg min-h-screen">
      <AnimatePresence mode="wait">
        {showSplash && (
          <motion.div
            key="splash"
            exit={{
              opacity: 0,
              filter: "blur(8px)",
              scale: 1.02,
            }}
            transition={{
              duration: 0.5,
              ease: "easeInOut",
            }}
            className="fixed inset-0 z-[99999]"
          >
            <SplashScreen
              onComplete={
                handleSplashComplete
              }
            />
          </motion.div>
        )}
      </AnimatePresence>

      {!showSplash && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 0.3,
          }}
        >
          <Nav
            showCart={
              activePage === "cart"
            }
            activePage={activePage}
          />

          <Suspense
            fallback={
              <SkeletonLoader />
            }
          >
            <div
              key={
                location.pathname
              }
            >
              <Outlet
                context={
                  outletContext
                }
              />
            </div>
          </Suspense>
        </motion.div>
      )}

      {!showSplash && (
        <>
          <Footer
            onCartClick={
              handleCartClick
            }
            onHomeClick={
              handleHomeClick
            }
            onSearchClick={
              handleSearchClick
            }
            onAccountClick={
              handleAccountClick
            }
            activeTab={
              activePage
            }
          />

          <FlyingCart />
        </>
      )}
    </div>
  );
};

export default MainLayout;